import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import isItemView from 'owa-mail-store/lib/utils/isItemView';
import conversationCache from 'owa-mail-store/lib/store/conversationCache';
import mailStore from 'owa-mail-store/lib/store/Store';

/**
 * Returns true if the item is currently cached by either prefetch or if item was viewed previously
 * @param itemId is the id of item to be checked
 * @param tableView is the current table view
 */
export default function isItemCached(itemId: string, tableView: TableView): boolean {
    if (isItemView(tableView)) {
        const item = mailStore.items.get(itemId);
        return !!item?.NormalizedBody;
    } else {
        return !!conversationCache.get(itemId);
    }
}
